import { GET_CRM_WEB_CONFIGURATION } from '../../constants/actions/CRMWebConfiguration';

export default function getCRMWebConfiguration() {
    return {
        type: GET_CRM_WEB_CONFIGURATION,
    };
}
